import { render, staticRenderFns } from "./CardTypeQA.vue?vue&type=template&id=3b6aafde&"
import script from "./CardTypeQA.vue?vue&type=script&lang=js&"
export * from "./CardTypeQA.vue?vue&type=script&lang=js&"
import style0 from "./CardTypeQA.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VForm,VIcon})
